export default "__VITE_ASSET__C5vrdvI3__"